var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.769 2c-.417.038-.771.414-.769.818v34.364c0 .428.404.818.848.818h26.304c.444 0 .848-.39.848-.818V11.818a.822.822 0 00-.252-.588l-.318-.294a.818.818 0 00-.106-.115L24.84 2.64a.87.87 0 00-.066-.05l-.358-.359a.875.875 0 00-.597-.23H6.768zm.928 1.636h15.697v7.773c0 .428.404.818.848.818h8.06v24.137H7.698V3.636zm17.394 1.56l5.595 5.395H25.09V5.196zm-1.697 10.292c-1.63 0-2.97 1.304-2.97 2.876 0 1.572 1.34 2.864 2.97 2.864 1.63 0 2.97-1.292 2.97-2.864 0-1.572-1.34-2.876-2.97-2.876zM17.362 20a.866.866 0 00-.57.307l-6.364 7.773a.812.812 0 00-.102.866.872.872 0 00.765.463H28.91a.87.87 0 00.78-.474.814.814 0 00-.13-.88l-5.09-5.728c-.303-.344-.916-.369-1.247-.051l-1.883 1.815-3.221-3.797a.88.88 0 00-.756-.294zm.093 2.122l3.155 3.708c.298.355.924.387 1.26.064l1.895-1.828 3.301 3.707H12.827l4.628-5.65z",
    fill: "#ED1B2E"
  })));
}

export default SvgImageIcon;